import { FunctionComponent } from 'react';
import { InlineNotification } from '@gaiads/telia-react-component-library';
import { ExcelUserImportErrorType } from '../../../../../utils/spreadsheetUtils';

type UploadErrorNotificationProps = {
  isPreScheduledOnboardingEnabled: boolean;
  errorGettingUsersFromUploadedFile: ExcelUserImportErrorType | undefined;
  resetUploadedFileData: () => void;
  t: (key: string) => string;
};

export const UploadErrorNotification: FunctionComponent<UploadErrorNotificationProps> = ({
  isPreScheduledOnboardingEnabled,
  errorGettingUsersFromUploadedFile,
  resetUploadedFileData,
  t,
}) => {
  const getErrorMessageGettingUsersFromUploadedFile = (): { title: string; messageText: string } => {
    const title = t('usersAdmin.importUsers.uploadTemplate.uploadErrorNotifications.title');
    switch (errorGettingUsersFromUploadedFile) {
      case ExcelUserImportErrorType.NoUsers:
        return { title, messageText: t('usersAdmin.importUsers.uploadTemplate.uploadErrorNotifications.noUsersMessage') };
      case ExcelUserImportErrorType.FormatNotSupported:
        return {
          title,
          messageText: t(
            isPreScheduledOnboardingEnabled
              ? 'usersAdmin.importUsers.uploadTemplate.uploadErrorNotifications.wronglyFormattedMessage'
              : 'usersAdmin.importUsers.uploadTemplate.uploadErrorNotifications.wronglyFormattedMessageNoFlag',
          ),
        };
      default:
        return { title, messageText: t('usersAdmin.importUsers.uploadTemplate.uploadErrorNotifications.generalMessage') };
    }
  };

  const { title, messageText } = getErrorMessageGettingUsersFromUploadedFile();
  return <InlineNotification title={title} messageText={messageText} closeOnClick={resetUploadedFileData} variant="error" />;
};
